export class Shape {
  constructor(difference) {
    this.styleId=1
    this.width = 200
    this.height = 200
    this.top = 10
    this.left = 10
    this.innerElement = "cxShape"
    this.bgType = "纯色" //纯色 线性渐变 径向渐变
    this.bgColor = "rgba(255,255,255,0)"
    this.bgStartColor = "rgba(23,241,255,1)"
    this.bgEndColor = "rgba(23,116,255,1)"
    this.rotate = 0
    this.borderWidth = 0
    this.borderStyle = "solid"
    this.borderColorType = "纯色" // 纯色
    this.borderColor = "#000000"
    this.borderChecked = true
    this.shapeType = "radius" // radius  clip round
    this.borderTopLeftRadius = 0
    this.borderTopRightRadius = 0
    this.borderBottomLeftRadius = 0
    this.borderBottomRightRadius = 0
    this.opacity = 100
    this.boxShadowColor = ["rgba(255,255,255,1)"]
    this.boxShadowH = [0]
    this.boxShadowV = [0]
    this.boxShadowBlur = [0]
    this.boxShadowSpread = [0]
    this.viewBox = "0 0 36 36"
    this.pathD1 = "M0 0h36v36H0V0z"
    this.pathD2 = "M35 1H1v34h34V1zM0 0v36h36V0H0z"
    this.pathD = ["M0 0h36v36H0V0z"]
    this.shapeUrl1 = "url(#paint0_linear_16708_225894)"
    this.shapeUrl2 = "url(#paint1_linear_16708_225894)"
    this.shapeColor1 = {
      type: "linear",
      x: 0,
      y: 0,
      x2: 0,
      y2: 1,
      colorStops: [
        { offset: 0, color: "#252D3A" },
        { offset: 1, color: "#252C38" }
      ]
    }
    this.shapeColor2 = {
      type: "linear",
      x: 0,
      y: 0,
      x2: 0,
      y2: 1,
      colorStops: [
        { offset: 0, color: "#17F1FF" },
        { offset: 1, color: "#1774FF" }
      ]
    }
    this.shapeColor = [
      {
        type: "linear",
        x: 0,
        y: 0,
        x2: 0,
        y2: 1,
        colorStops: [
          { offset: 0, color: "#252D3A" },
          { offset: 1, color: "#252C38" }
        ]
      }
    ]
    this.shapeBorderColor = [
      {
        type: "linear",
        x: 0,
        y: 0,
        x2: 0,
        y2: 1,
        colorStops: [
          { offset: 0, color: "#17F1FF" },
          { offset: 1, color: "#1774FF" }
        ]
      }
    ]
    this.linearGradient1 = "paint0_linear_16708_225894"
    this.linearGradient2 = "paint1_linear_16708_225894"
    this.linearGradient = ["paint0_linear_16708_225894"]
    this.bgAngleValue1 = "0°"
    this.bgAngleValue2 = "0°"
    this.bgAngleValue = ["0°"]
    this.borderLinearGradient = ["paint0_linear_16708"]
    this.clipPath = "none"
    this.skew = "0"
    this.iconPosition = "left" // left,right
    this.iconSrc = ""
    this.iconWidth = 14
    this.iconColorIsThemeColor = false
    this.iconColor = "#444444"
    // this.animateSets = {}
    this.init(difference)
  }
  init(difference) {
    for (let key in difference) {
      this[key] = difference[key]
    }
  }
}
export class HomeShape extends Shape {
  constructor(difference) {
    super(difference)
    this.bgColor = ""
    this.viewBox = "0 0 44 44"
    this.pathD1 = "M0 0H44V44H0V0Z"
    this.pathD2 = ""
    this.pathD = ["M0 0H44V44H0V0Z"]
    this.shapeUrl1 = "url(#paint0_linear_16708_225676)"
    this.shapeUrl2 = ""
    this.shapeColor1 = {
      type: "linear",
      x: 0,
      y: 0,
      x2: 0,
      y2: 1,
      colorStops: [
        { offset: 0, color: "#649FFF" },
        { offset: 1, color: "#649FFF" }
      ]
    }
    this.shapeColor2 = ""
    this.shapeColor = [
      {
        type: "linear",
        x: 0,
        y: 0,
        x2: 0,
        y2: 1,
        colorStops: [
          { offset: 0, color: "#649FFF" },
          { offset: 1, color: "#649FFF" }
        ]
      }
    ]
    this.shapeBorderColor = [
      {
        type: "linear",
        x: 0,
        y: 0,
        x2: 0,
        y2: 1,
        colorStops: [
          { offset: 0, color: "#649FFF" },
          { offset: 1, color: "#649FFF" }
        ]
      }
    ]
    this.linearGradient1 = "paint0_linear_16708_225676"
    this.linearGradient2 = ""
    this.linearGradient = ["paint0_linear_16708_225676"]
    this.init(difference)
  }
  init(difference) {
    for (let key in difference) {
      this[key] = difference[key]
    }
  }
}
